import React from 'react';
import { useTheme } from '@/contexts/ThemeContext';

export default function Logo({ size = 120, className = '', style = {}, variant = 'auto', iconOnly = false }) {
    const { theme } = useTheme();

    const isHighContrast = theme === 'high-contrast';
    const isDarkMode = theme === 'dark' || isHighContrast;
    
    // Explicit override checks
    const forceDark = variant === 'dark';
    const forceLight = variant === 'light';
    
    const shouldInvert = forceDark || (variant === 'auto' && isDarkMode) || (forceLight === false && isDarkMode);

    const fullLogoSrc = shouldInvert ? "/brand/oblique-dark.svg" : "/brand/Oblique.svg";
    const iconSrc = shouldInvert ? "/brand/oblique-dark-icon.svg" : "/brand/oblique-light-icon.svg";

    const iconWidth = iconOnly ? (size || 28) : size;

    return (
        <div 
            className={`relative h-6 flex items-center transition-all duration-300 ${className}`}
            style={{ width: iconWidth, ...style }}
        >
            {/* Full Logo */}
            <img
                src={fullLogoSrc}
                alt="Oblique"
                className={`absolute left-0 top-1/2 -translate-y-1/2 h-auto origin-left transition-opacity duration-200 ${iconOnly ? 'opacity-0 invisible pointer-events-none' : 'opacity-100 visible'}`}
                style={{ width: size }}
            />
            {/* Icon Only Logo */}
            <img
                src={iconSrc}
                alt="Oblique Icon"
                className={`absolute left-0 top-1/2 -translate-y-1/2 h-auto origin-left transition-opacity duration-200 ${iconOnly ? 'opacity-100 visible' : 'opacity-0 invisible pointer-events-none'}`}
                style={{ width: iconWidth }}
            />
        </div>
    );
}
